export default class PreferencesService {
    /* @ngInject */
    constructor(apiService) {
        this.apiService = apiService;
    }

    get() {
        return this.apiService.get(`/users/me/preferences`).then((result) => result.data);
    }

    save(preferences) {
        return this.apiService.put(`/users/me/preferences`, preferences).then((result) => result.data);
    }
}



// WEBPACK FOOTER //
// ./src/application/service/user/preference.service.js